<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card width="800px">
        <v-toolbar color="blue white--text darken-3" flat>
          <v-toolbar-title>Generar Nota Debito Credito.</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pt-4">
          <div>
            <p class="mb-0"><b>Nombre Razon Social:</b> {{ venta.nombreRazonSocial }}</p>
            <p class="mb-0"><b>Documento:</b> {{ venta.numeroDocumento }}</p>
            <p class="mb-0"><b>Factura #:</b>{{ venta.numeroFactura }}</p>
          </div>
          <v-data-table
            :headers="headers"
            :items="desserts"
            v-model="seleccionados"
            :single-select="single"
            show-select
            class="elevation-1 mt-2"
          >
            <!-- <template v-slot:top>
              <v-switch v-model="single" label="Seleccionar varios" class="pa-3"></v-switch>
            </template> -->
          </v-data-table>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" :disabled="loading" dark small tile @click="generarnotadc()">
            <v-icon class="mr-1"> mdi-file-cancel</v-icon> Generar Nota
          </v-btn>
          <v-btn color="blue darken-1" outlined tile @click="dialog = !dialog">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        single: false,
        msg: '',
        venta: {},
        seleccionados: [],
        headers: [
          { text: 'Actividad Economica', value: 'actividadEconomica' },
          { text: 'Descripcion', value: 'descripcion' },
          { text: 'Unidad', value: 'unidadDescripcion' },
          { text: 'Cantidad', value: 'cantidad' },
          { text: 'Precio Unitario', value: 'precioUnitario' },
          { text: 'SubTotal', value: 'subTotal' },
        ],
        desserts: [],
      };
    },
    components: {},
    watch: {},
    methods: {
      async openmodal(data) {
        window.console.log('regnota:::', data);
        this.dialog = true;
        this.msg = '';
        this.seleccionados = [];
        this.desserts = [];
        this.venta = {};
        if (data.cuf) this.getFacturaData(data.cuf);
      },
      getFacturaData(cuf) {
        let vue = this;
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/cuf/${cuf}`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('getFacturaData: ', data);
            vue.desserts = data.detalle;
            vue.venta = data.Venta;
            vue.loading = false;
          })
          .catch(function(error) {
            let data = error;
            window.console.log(data);
            vue.loading = false;
          });
      },
      generarnotadc() {
        this.msg = '';
        if (this.seleccionados.length == 0) this.msg = 'Debe seleccionar al menos 1 item.';
        if (this.msg) return;

        window.alert('En desarrollo');
      },
    },
    mounted() {},
  };
</script>

<style></style>
